import { render, staticRenderFns } from "./PrivacyPolicyContainer.vue?vue&type=template&id=72579282"
import script from "./PrivacyPolicyContainer.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyContainer.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyContainer.vue?vue&type=style&index=0&id=72579282&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports